import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDot(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <circle cx={8} cy={8} r={3} fill="currentColor" />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDot);
export default ForwardRef;
